import { authenticatedAxios } from "lib/actions/fetcher";
import { endpointsIssues } from "lib/actions/endpoints/endpointsIssues";
import { IssueCreateRequestModel } from "components/modules/Issues/lib/types/IssueCreateRequestModel";
import { IssueResponseModel } from "components/modules/Issues/lib/types/IssueResponseModel";

export async function issueCreate(
  projectId: number,
  issue: IssueCreateRequestModel,
): Promise<IssueResponseModel> {
  issue.assignedToType = "user";
  const response = await authenticatedAxios.request({
    ...endpointsIssues.projectIssueCreate(projectId),
    data: issue,
  });
  return response.data;
}
